module.exports = __webpack_public_path__ + "img/portfolio-thumb.d38215a2.webp";